<template>
    <div class="deliveryAddressCard__action" @click="restartSubscription" :disabled="isProcessing">
        <div>
            <p class="no-margin" v-text="$t('RESTART_DELIVERY_ACTION')"></p>
            <p class="error" v-text="error" v-if="error"></p>
        </div>
        <img class="deliveryAddressCard__actionIcon" src="@/assets/images/decoration/arrow-right-black.svg">
    </div>
</template>

<script>
import SubscriptionService from '@/services/subscriptions/SubscriptionService';

let subscriptionService = new SubscriptionService();

export default {
    name: 'RestartDeliveriesAction',
    data() {
        return {
            isProcessing: false,
            error: null,
        };
    },
    props: {
        address: {
            required: true,
            type: Object,
        },
        subscription: {
            required: true,
            type: Object,
        },
    },
    methods: {
        restartSubscription() {
            if (this.isProcessing === false) {
                this.handleCreatingClonedSubscriptionViaApi();
            }
        },

        handleCreatingClonedSubscriptionViaApi() {
            let newAddress = {
                firstName: this.authUser.first_name,
                lastName: this.authUser.last_name,
                address1: this.address.address1,
                address2: this.address.address2,
                houseNumber: this.address.houseNumber,
                city: this.address.city,
                country: process.env.VUE_APP_COUNTRY_ISO,
                postcode: this.address.postcode,
                deliveryComment: this.subscription.delivery_comment || 'Porch',
                propertyType: this.address.property_type,
            };

            this.toggleProcessing();

            subscriptionService.createSubscription(newAddress)
                .then(() => {
                    this.$scrollTo('.main');
                    this.$emit('restarted');

                    setTimeout(() => {
                        this.$store.dispatch('subscription/fetchAllSubscriptions', true);
                        this.$store.dispatch('address/fetchAllAddresses', true);
                    }, 50);
                })
                .catch(() => {
                    this.error = 'Sorry - something went wrong restarting deliveries to ' +
                        'this address. Please try again shortly.';
                });

            this.toggleProcessing();
        },

        toggleProcessing() {
            this.isProcessing = !this.isProcessing;
        },
    },
    computed: {
        authUser() {
            return this.$store.getters['account/getUser'];
        },
    },
};
</script>
